import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=1be94f02&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"
import style0 from "./shop.vue?vue&type=style&index=0&id=1be94f02&prod&lang=css"
import style1 from "./shop.vue?vue&type=style&index=1&id=1be94f02&prod&scoped=true&lang=css"
import style2 from "./shop.vue?vue&type=style&index=2&id=1be94f02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be94f02",
  null
  
)

export default component.exports